var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VerifyCheckHeader',{attrs:{"img_header":_vm.header_image,"header":"รอตรวจสอบ","link_back":"stock"}}),_c('Verify_main')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }